import qs from 'qs';
import { createAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import Notify from 'utils/Notify';

import http from 'app/services/httpService';
import { callWrapperSaga } from 'app/services/sagaService';
import apiEndpoints, { buildApiRoute } from 'routes/apiEndpoints';

import {
  getCustomerKycDocumentFailure,
  getCustomerKycDocumentInit,
  getCustomerKycDocumentSuccess,
  syncCustomerKycDocumentInit,
  syncCustomerKycDocumentFailure,
  syncCustomerKycDocumentSuccess,
} from './customerKycDocumentSlice';

const getCustomerKycDocument = createAction('customerKycDocument/get');
const syncCustomerKycDocument = createAction('customerKycDocument/sync');

function* getCustomerKycDocumentSaga({ payload: customerId }) {
  try {
    yield put(getCustomerKycDocumentInit());
    const endpoint = buildApiRoute(apiEndpoints.getCustomerKycDocument, customerId);
    const response = yield callWrapperSaga(() => http.get(endpoint));
    yield put(getCustomerKycDocumentSuccess(response.data));
  } catch (err) {
    yield put(getCustomerKycDocumentFailure(err));
  }
}
function* syncCustomerKycDocumentSaga({ payload: userId }) {
  try {
    yield put(syncCustomerKycDocumentInit());
    const endpoint = buildApiRoute(apiEndpoints.syncKycDocument, userId);
    yield callWrapperSaga(() => http.put(endpoint, {}));
    yield put(syncCustomerKycDocumentSuccess());
    yield put(getCustomerKycDocument(userId));
    Notify.success('Documents synced successfully.');
  } catch (err) {
    yield put(syncCustomerKycDocumentFailure());
    yield put(getCustomerKycDocument(userId));
    const msg =
      err?.response?.data?.message || err?.response?.data?.error || 'Failed to sync documents';
    Notify.error(typeof msg === 'string' ? msg : 'Failed to sync documents');
  }
}

function* customerKycDocumentSaga() {
  yield takeLatest(getCustomerKycDocument, getCustomerKycDocumentSaga);
  yield takeLatest(syncCustomerKycDocument, syncCustomerKycDocumentSaga);
}

export default customerKycDocumentSaga;
export { getCustomerKycDocument, syncCustomerKycDocument };
